import React from 'react';
import './card.css';
import {Grid, Typography, Box} from '@mui/material';
import styles from './HomeNew.module.css';
import {useNavigate} from 'react-router-dom';
import {PiMapPinSimpleLine} from 'react-icons/pi';
import {IoMailOutline} from 'react-icons/io5';
import {BsPhone} from 'react-icons/bs';
import {FaFacebookSquare} from 'react-icons/fa';
import {SiLinkedin} from 'react-icons/si';

const Footer = () => {
  const navigate = useNavigate ();
  return (
    <div className="footer">
      <Grid container>
        <Grid item xs={12} sm={6} md={4} lg={4} sx={{margin: '14px 0'}}>
          <Box className={styles.footer_span}>
            <span>
              <Typography
                sx={{
                  marginBottom: '10px',
                  fontSize: '22px !important',
                  marginLeft: '25px',
                  marginTop: '10px',
                }}
              >
                <b>Importants Links </b>
              </Typography>
              <div className="footer-section">
                {/* // style={{width: '20%'}} */}
                <ul style={{fontSize: '16px', cursor: 'pointer'}}>
                  <li onClick={() => navigate ('//')}>Home</li>

                  <li onClick={() => navigate ('/our-platform')}>
                    Our Platform
                  </li>
                  <li onClick={() => navigate ('/about-us')}>About Us</li>
                  <li onClick={() => navigate ('/contact-us')}>Contact Us</li>
                  <li onClick={() => navigate ('/login')}>
                    IT Recruiter Login
                  </li>
                  <li onClick={() => navigate ('/login')}>
                    Bench Sales Recruiter Login
                  </li>
                  {/* <li>Our Leaders</li>
                  <li>Frequently Ask Question (FAQ)</li> */}
                </ul>
              </div>
            </span>
            {/* <span
              style={{
                marginBottom: window.innerWidth <= 768 ? "10px" : "115px",
              }}
            >
              <Typography
                sx={{
                  marginBottom: "5px",
                  fontSize: "22px !important",
                  marginLeft: "25px",
                  marginTop: "20px",
                }}
              >
                <b>Importants Links </b>
              </Typography>
              <div className="footer-section">
                <ul style={{ fontSize: "16px" }}>
                 
                </ul>
              </div>
            </span> */}
          </Box>
        </Grid>
        {/* <Grid
          item
          xs={12}
          sm={6}
          md={8}
          lg={8}
          className={styles.footer_details}
        >
          <span>
            <div className="footer-section">
              <ul style={{ fontSize: "16px" }}>
                <li>
                  <a href="#">Security & Fraud</a> |
                  <a href="#">Privacy Policy</a> |
                  <a href="#">Beware of Fraudsters</a> |
                  <a href="#">Term of Use</a>
                </li>
                <li>Phone No: +91 98738-53335 | +91 70772-03570</li>
                <li>WhatsApp No: 94270-22407</li>
                <li>Email ID: Help@povital.com</li>
              </ul>
            </div>
          </span>
        </Grid> */}
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={4}
          className={styles.office_details}
        >
          <span>
            <Typography
              sx={{marginBottom: '15px', fontSize: '20px !important'}}
            >
              <b>Povital Offices </b>
            </Typography>

            <span className={styles.profile_details_view}>
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  // padding: "4px 0 4px 0",
                  marginBottom: '10px',
                }}
              >
                <Typography>
                  <div
                    style={{
                      backgroundColor: '#2d4696',
                      cursor: 'pointer',
                      borderRadius: '3px ',
                    }}
                  >
                    <PiMapPinSimpleLine
                      style={{
                        fontSize: '27px',
                        marginBottom: '2px',
                        padding: '4px 0 2px 0',
                      }}
                    />
                  </div>
                </Typography>
              </span>
              <Typography
                component="span"
                sx={{
                  marginLeft: '10px',
                  fontSize: '16px !important',
                  lineHeight: '1.8',
                }}
              >
                Plat No 186 B, Basanti Bagh, Tehsil Baddi, Solan,
                <br />
                Himanchal Pradesh, 173204
              </Typography>
            </span>

            <span
              className={styles.profile_details_view}
              style={{marginTop: '10px'}}
            >
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  // padding: "4px 0 4px 0",
                  marginBottom: '10px',
                }}
              >
                <Typography>
                  <div
                    style={{
                      backgroundColor: '#2d4696',
                      cursor: 'pointer',
                      borderRadius: '3px ',
                    }}
                  >
                    <PiMapPinSimpleLine
                      style={{
                        fontSize: '27px',
                        marginBottom: '2px',
                        padding: '4px 0 2px 0',
                      }}
                    />
                  </div>
                </Typography>
              </span>

              <Typography
                component="span"
                sx={{
                  marginLeft: '10px',
                  fontSize: '17px !important',
                  lineHeight: '1.8',
                }}
              >
                Plat No 217 Rasulghar, Bomikhal Khorda,
                <br />
                Bhubaneswar , 754002
              </Typography>
            </span>
            {/* <span
              className={styles.profile_details_view}
              style={{marginTop: '10px'}}
            >
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  // padding: "4px 0 4px 0",
                  marginBottom: '10px',
                }}
              >
                <Typography>
                  <div
                    style={{
                      backgroundColor: '#2d4696',
                      cursor: 'pointer',
                      borderRadius: '3px ',
                    }}
                  >
                    <PiMapPinSimpleLine
                      style={{
                        fontSize: '27px',
                        marginBottom: '2px',
                        padding: '4px 0 2px 0',
                      }}
                    />
                  </div>
                </Typography>
              </span>

              <Typography
                sx={{
                  marginLeft: '10px',
                  fontSize: '17px !important',
                  lineHeight: '1.8',
                }}
              >
                2075 Tabasco Cat Trail Frisco, Texas 75035, US
              </Typography>
            </span> */}
          </span>

        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={4}
          className={styles.office_details}
        >
          <span>
            <Typography
              sx={{marginBottom: '15px', fontSize: '20px !important'}}
            >
              <b>Get in Touch </b>
            </Typography>

            <span className={styles.profile_details_view}>
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  // padding:'2px 0 0 2px',
                  marginBottom: '10px',
                }}
              >
                <Typography>
                  <div
                    style={{
                      backgroundColor: '#2d4696',
                      cursor: 'pointer',
                      borderRadius: '3px ',
                    }}
                  >
                    <IoMailOutline
                      style={{
                        fontSize: '27px',
                        marginBottom: '2px',
                        padding: '4px 0 2px 0',
                      }}
                    />
                  </div>
                </Typography>
              </span>
              <Typography
                component="span"
                sx={{
                  marginLeft: '10px',
                  fontSize: '16px !important',
                  lineHeight: '1.8',
                }}
              >
                Email: contact@povital.com
              </Typography>
            </span>

            <span
              className={styles.profile_details_view}
              style={{marginTop: '10px'}}
            >
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  // padding: "4px 0 4px 0",
                  marginBottom: '10px',
                }}
              >
                <Typography>
                  <div
                    style={{
                      backgroundColor: '#2d4696',
                      cursor: 'pointer',
                      borderRadius: '3px ',
                    }}
                  >
                    <BsPhone
                      style={{
                        fontSize: '27px',
                        marginBottom: '2px',
                        padding: '4px 0 2px 0',
                      }}
                    />
                  </div>
                </Typography>
              </span>

              <Typography
                sx={{
                  marginLeft: '10px',
                  fontSize: '16px !important',
                  lineHeight: '1.8',
                }}
              >
                India: +91 98738 53335
              </Typography>
            </span>
            {/* <span
              className={styles.profile_details_view}
              style={{marginTop: '10px'}}
            >
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  // padding: "4px 0 4px 0",
                  marginBottom: '10px',
                }}
              >
                <Typography>
                  <div
                    style={{
                      backgroundColor: '#2d4696',
                      cursor: 'pointer',
                      borderRadius: '3px ',
                    }}
                  >
                    <BsPhone
                      style={{
                        fontSize: '27px',
                        marginBottom: '2px',
                        padding: '4px 0 2px 0',
                      }}
                    />
                  </div>
                </Typography>
              </span>

              <Typography
                sx={{
                  marginLeft: '10px',
                  fontSize: '16px !important',
                  lineHeight: '1.8',
                }}
              >
                USA: +1 430 407 5520{' '}
              </Typography>
            </span> */}
          </span>
          <Box
            sx={{
              display: {xs: 'block', sm: 'none'}, // Display on mobile only
              marginTop: '20px',
            }}
          >
            <div className="footer-section-secruity">
              <ul style={{fontSize: '16px'}}>
                <a>
                  <a href="/security">Privacy Policy </a> |
                  <a href="/security">Website Terms of Use</a> |
                  <a href="/security"> Security</a> |
                  <a href="/security">Reporting fraud</a>
                </a>
              </ul>
            </div>
          </Box>
          <Box className={styles.icon_details}>
            <a
              href="https://www.facebook.com/povitalportal/"
              target="_blank"
              rel="noopener noreferrer"
              style={{color: '#fff'}}
            >
              <FaFacebookSquare
                style={{
                  fontSize: '36px',
                  marginRight: '20px',
                  cursor: 'pointer',
                }}
              />
            </a>
            {/* <a
              href="https://www.linkedin.com/company/povitalportal/"
              target="_blank"
              rel="noopener noreferrer"
              style={{color: '#fff'}}
            >
              <SiLinkedin style={{fontSize: '32px', cursor: 'pointer'}} />
            </a> */}
          </Box>
        </Grid>
        <Box
          sx={{
            display: {xs: 'none', sm: 'block'},
            marginTop: '25px',
          }}
        >
          <div className="footer-section-secruity">
            <ul style={{fontSize: '16px'}}>
              <a>
                <a href="/privacy-policy">Privacy Policy </a> |
                <a href="/refund-policy">Refund Policy </a> |
                <a href="/term-of-use">Website Terms of Use</a> |
                <a href="/data-backup-policy"> Security</a> |
                <a href="/reporting-fraud">Reporting fraud</a>
              </a>
            </ul>
          </div>
        </Box>
      </Grid>

    </div>
  );
};

export default Footer;
